<template>
  <div>
    <d-table ref="table" :data="toDos" :show-detail-icon="false" :loading="loadingToDos" paginated backend-pagination detailed :total="total" backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped detail-key="id" default-sort-direction="desc" :per-page="pagination.pageSize" @page-change="page => pagination.page = page" @sort="onSort">
      <template #action-buttons>
        <h2 class="mb-0 text-primary-500">
          Assignment Tasks
        </h2>
      </template>

      <template #action-buttons-right>
        <filter-dropdown v-model="filter" />
        <div class="flex space-x-4">
          <d-btn class="" @click.native="launchToDoTemplateModal()">
            + New Task
          </d-btn>
        </div>
      </template>

      <template slot-scope="props">
        <d-table-column field="name" :row="props.row" label="Title" sortable />
        <d-table-column field="startDate" :row="props.row" label="Start Date" sortable>
          {{ props.row.startDateDisplay }}
        </d-table-column>
        <d-table-column field="dueDate" :row="props.row" label="Due Date" sortable>
          {{ props.row.dueDate | formatShortDate }}
        </d-table-column>
        <d-table-column field="preRequisiteWorkItemName" :row="props.row" label="Pre-requisite">
          {{ props.row.preRequisiteWorkItemName ? props.row.preRequisiteWorkItemName : 'None' }}
        </d-table-column>
        <d-table-column class="text-right">
          <d-tooltip label="Duplicate todo">
            <d-icon icon="copy" class="cursor-pointer text-black ml-4" @click.native="launchDuplicateToDoTemplateModal(props.row)" />
          </d-tooltip>
          <d-icon icon="edit" class="cursor-pointer text-green-500 ml-4" @click.native="launchToDoTemplateModal(props.row)" />
          <d-icon icon="trash" class="cursor-pointer text-red-500 ml-4" @click.native="removeToDoTemplate(props.row)" />
        </d-table-column>
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import ToDoItemTemplateModal from './ToDoItemTemplateModal';

  export default {
    name: 'ToDosPage',
    parent: true,
    props: {
      assignment: {
        type: Object,
        default: () => {},
      },
    },
    data: () => ({
      toDos: [],
      loadingToDos: false,
      total: 0,
      filter: '',
      pagination: {
        page: 1,
        pageSize: 50,
        sortField: '',
        sortOrder: '',
      },
    }),

    watch: {
      pagination: {
        handler() {
          this.getToDoItemsByAssignmentId();
        },
        deep: true,
      },
      filter() {
        this.getToDoItemsByAssignmentId();
      },
    },

    mounted() {
      this.getToDoItemsByAssignmentId();
    },

    methods: {

      async getToDoItemsByAssignmentId() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `assignmentTemplateId=${this.assignment.id}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingToDos = true;
        const { data } = await axios.get(`/api/admin/assignment/todo-items/paged?${params}`);
        this.toDos = data.resultItems;
        this.total = data.totalRecords;
        this.loadingToDos = false;
      },

      launchToDoTemplateModal(toDo) {
        this.$modal.open({
          parent: this,
          component: ToDoItemTemplateModal,
          hasModalCard: true,
          canCancel: ['button', 'x'],
          width: 600,
          events: {
            getToDoItemsByAssignmentId: () => this.getToDoItemsByAssignmentId(),
          },
          props: {
            toDo,
            assignment: this.assignment,
            duplicate: false,
          },
        });
      },

      launchDuplicateToDoTemplateModal(toDo) {
        this.$modal.open({
          parent: this,
          component: ToDoItemTemplateModal,
          hasModalCard: true,
          canCancel: ['button', 'x'],
          width: 600,
          events: {
            getToDoItemsByAssignmentId: () => this.getToDoItemsByAssignmentId(),
          },
          props: {
            toDo,
            assignment: this.assignment,
            duplicate: true,
          },
        });
      },

      async removeToDoTemplate(template) {
        this.$dialog.confirm({
          title: 'Removing ToDo Item Template',
          message: `Are you sure you want to <b>remove</b> <i>${template.name}</i>? This action cannot be undone.`,
          confirmText: 'Remove',
          confirmColor: 'red-500',
          onConfirm: async () => {
            try {
              await axios.delete(`/api/admin/todo-items/${template.id}`);
              this.getToDoItemsByAssignmentId();
              this.$toast.open('ToDo Item Template removed!');
            } catch (error) {
              this.$toast.open({ message: error.response.data, color: 'red-500', duration: 4000 });
            }
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },

    },
  };
</script>
